<!-- 主页面 -->
<template>
  <div class="image dashboard" style="display: flex; flex-wrap: wrap;">
    <div class="md-size-33 md-layout-item charts-box" v-for="key in showItem" :key="'show_' + key">
      <!-- 服务器信息 -->
      <template v-if="key == (1)">
        <p class="title">{{$I18n("svr_info")}}</p>
        <div class="box-div" style="">
          <el-select type="select" v-model="sl_ip" class="select-div">
            <el-option :key="ip.id" :value="ip.id" :label="ip.ip" v-for="ip in ips"/>
          </el-select>
          <div style="display: flex;">
            <chart-el :options="memoryCharts" class="ip-charts"></chart-el>
            <chart-el :options="cpuCharts" class="ip-charts"></chart-el>
            <chart-el :options="hdCharts" class="ip-charts"></chart-el>
          </div>
        </div>
      </template>
      <!-- 服务连接状态 -->
      <template v-if="key == (2)">
        <p class="title">{{$I18n("svr_con_state")}}</p>
        <div class="box-div box-div-03">
          <div>
            <md-table class="dashboard-table" v-model="tableData_srv">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <!-- <md-table-cell :md-label="$I18n('name')"> -->
                <md-table-cell :md-label="$I18n('type')">
                  {{item.t_type_name}}[{{item.ip}}]
                </md-table-cell>
                <md-table-cell :md-label="$I18n('status')">
                  <span :style="{color: item.state == 1 ?'#00CC1F' :'#FF0004',fontWeight: 600}">{{item.t_state_name}}</span>
                </md-table-cell>
                <md-table-cell :md-label="$I18n('que_time')">
                  {{item.t_update_time}}
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
          </div>
        </div>
      </template>
      <!-- 今日报警推送记录 -->
      <template v-if="key == (3)">
        <p class="title">{{$I18n("today_alarm_log")}}</p>
        <div class="box-div" style="display: flex;align-items: center;">
          <div class="md-layout-item md-size-33">
            <img class="small-img" src="../../../public/img/Group 4.png" />
            <p class="small-title title-top">{{$I18n("alarm_total")}}</p>
            <p class="small-title">{{alm_s + alm_f}}</p>
          </div>
          <div class="md-layout-item md-size-33">
            <img class="small-img" src="../../../public/img/Group 7.png" />
            <p class="small-title title-top">{{$I18n("push_succ")}}</p>
            <p class="small-title">{{alm_s}}</p>
          </div>
          <div class="md-layout-item md-size-33">
            <img class="small-img" src="../../../public/img/Group 4.png" />
            <p class="small-title title-top">{{$I18n("push_fail")}}</p>
            <p class="small-title">{{alm_f}}</p>
          </div>
        </div>
      </template>
      <!-- 物联网卡状态（天） -->
      <template v-if="key == (4)">
        <p class="title">{{$I18n("iot_sim")}}</p>
        <div class="box-div" style="">
          <chart-el :options="ncCharts" class="net-card-charts"></chart-el>
        </div>
      </template>
      <!-- 电话外呼统计（天） -->
      <template v-if="key == (5)">
        <p class="title">{{$I18n("phone_count_day")}}</p>
        <div class="box-div" style="">
          <chart-el :options="phCharts" class="net-card-charts"></chart-el>
        </div>
      </template>
      <!-- 今日短信发送数量 -->
      <template v-if="key == (6)">
        <p class="title">{{$I18n("today_msg_count")}}</p>
        <div class="box-div" style="">
          <chart-el :options="msgCharts" class="msg-charts"></chart-el>
        </div>
      </template>
      <!-- 短信统计（天） -->
      <template v-if="key == (7)">
        <p class="title">{{$I18n("sms_stati")}}</p>
        <div class="box-div" style="">
          <chart-el class="flatinfo-charts" :options="smweekCharts"></chart-el>
        </div>
      </template>
      <!-- 今日邮件发送数量 -->
      <template v-if="key == (8)">
        <p class="title">{{$I18n("email_send")}}</p>
        <div class="box-div" style="">
          <chart-el class="flatinfo-charts" :options="emdayCharts"></chart-el>
        </div>
      </template>
      <!-- 邮件统计（天） -->
      <template v-if="key == (9)">
        <p class="title">{{$I18n("email_stati")}}</p>
        <div class="box-div" style="">
          <chart-el class="flatinfo-charts" :options="emweekCharts"></chart-el>
        </div>
      </template>
      <!-- 平台概览 -->
      <template v-if="key == (10)">
        <p class="title">{{$I18n("dev_state")}}</p>
        <div class="box-div" style="display: flex; align-items: center;">
          <div class="md-layout-item md-size-33">
            <img class="small-img" src="../../../public/img/Group 1.png" />
            <p class="small-title title-top-02">{{$I18n("total_device")}}</p>
            <p class="small-title">{{p2p_on_c + p2p_off_c}}</p>
          </div>
          <div class="md-layout-item md-size-33">
            <img class="small-img" src="../../../public/img/Group 2.png" />
            <p class="small-title title-top-02">{{$I18n("total_on")}}</p>
            <p class="small-title">{{p2p_on_c}}</p>
          </div>
          <div class="md-layout-item md-size-33">
            <img class="small-img" src="../../../public/img/Group 3.png" />
            <p class="small-title title-top-02">{{$I18n("total_off")}}</p>
            <p class="small-title">{{p2p_off_c}}</p>
          </div>
        </div>
      </template>
      <template v-if="key == (11)">
        <p class="title">{{$I18n("uid_auth")}}</p>
        <div class="box-div" style="">
          <chart-el :options="uidCharts" class="flatinfo-charts"></chart-el>
        </div>
      </template>
      <div v-if="key == ('6_11')" style="display: flex;">
        <div style="flex: 1;">
          <p class="title">{{$I18n("today_msg_count")}}</p>
          <div class="box-div" style="">
            <chart-el :options="msgCharts" class="msg-charts"></chart-el>
          </div>
        </div>
        <div style="width:10px;height: 100%;"></div>
        <div style="flex: 1;">
          <p class="title">{{$I18n("uid_auth")}}</p>
          <div class="box-div" style="">
            <chart-el :options="uidCharts" class="flatinfo-charts"></chart-el>
          </div>
        </div>
      </div>
      <!-- 注册用户 -->
      <template v-if="key == (12)">
        <p class="title">{{$I18n("reg_user")}}</p>
        <div class="box-div" style="">
          <chart-el class="flatinfo-charts" :options="regCharts"></chart-el>
        </div>
      </template>
      <!-- 待办任务 -->
      <template v-if="key == (13)">
        <p class="title">{{$I18n("todotask")}}</p>
        <div class="box-div box-div-03" style="">
          <div style="display: flex; flex-direction: column;">
            <div v-for="(item,index) in tableData_agency" :key="'todo_' + index" class="quest">
              <div class="quest-info">{{item.body}}</div>
              <div class="quest-date">{{item.create_date}}</div>
            </div>
          </div>
        </div>
      </template>
      <!-- 14: 本周设备状态 -->
      <template v-if="key == (14)">
        <p class="title">{{$I18n("dev_week_sta")}}</p>
        <div class="box-div">
          <chart-el class="flatinfo-charts" :options="wDevCharts"></chart-el>
        </div>
      </template>
      <!-- 15: 本周设备授权 -->
      <template v-if="key == (15)">
        <p class="title">{{$I18n("dev_week_auth")}}</p>
        <div class="box-div">
          <chart-el class="flatinfo-charts" :options="wAuthCharts"></chart-el>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { nDaysAgo, timestampToString1000 } from "@/common/tools.js"; // timestampToString , 
// import * as echarts from "echarts";
import {getGauge} from "@/pages/Dashboard/ChartsOptions/gaugeOptions.js";
import {getBar} from "@/pages/Dashboard/ChartsOptions/barOptions.js";
import {getPie} from "@/pages/Dashboard/ChartsOptions/pieOptions.js";
import {getLine} from "@/pages/Dashboard/ChartsOptions/lineOptions.js";
import ChartEl from "@/pages/Dashboard/ChartsOptions/ChartEl.vue";

const showItemList = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
// const ChartInitFuncObj = {
//   setOption: () => {},
//   resize: () => {},
// }
export default {
  components: {
    ChartEl,
  },
  props: ["userinfo_sys"],
  data(){
    return {
      showItem: [], // 展示的表格
      input: "",

      // 1：服务器信息 - IP 选择
      ips: [],
      sl_ip: "",
      // 1：服务器信息
      memoryCharts: null,
      cpuCharts: null,
      hdCharts: null,
      // 2：服务器状态
      tableData_srv: [ ],   
      // 3：今日报警推送记录
      alm_s : 0,
      alm_f : 0,
      // 4：物联网卡状态
      ncCharts: null,
      // 5：本周电话外呼统计
      phCharts: null,
      // 6：今日短信统计
      msgCharts: null,
      // 7：每周短信统计
      smweekCharts: null,
      // 8：今日邮件统计
      emdayCharts: null,
      // 9：每周邮件统计
      emweekCharts: null,
      // 10：设备状态
      p2p_on_c: 0,
      p2p_off_c: 0,
      // 11：UID授权
      uidCharts: null,
      // 12：本周注册用户
      regCharts: null,
      // 13：待办任务
      tableData_agency: [ ],
      // 14: 本周设备状态
      wDevCharts: null,
      // 15: 本周设备授权
      wAuthCharts: null,
    }
  },
  computed:{ },
  watch:{
    sl_ip(newValue){
      if(!this.showItem.includes(1)){
        return
      }
      const ip = this.ips.filter(i => i.id == newValue)[0];
      // 内存占用率 左上
      if(ip.memory_rate){
        const m_js = JSON.parse(ip.memory_rate);
        const m_used = parseFloat(m_js.used.replace("GB", ""));
        const m_total= parseFloat(m_js.total.replace("GB", ""));
        if(isNaN(m_used) || isNaN(m_total) || m_total == 0){
          this.memoryCharts = getGauge(0 , "#4BAAE4", this.$I18n("mem_usage"))
        } else {
          this.memoryCharts = getGauge(Math.round(m_used*100/m_total) , "#4BAAE4", this.$I18n("mem_usage"))
        }
      } else {
        this.memoryCharts = getGauge(0 , "#4BAAE4", this.$I18n("mem_usage"))
      }
      // CPU占用率
      if(ip.cpu_rate){
        this.cpuCharts = getGauge(
          Math.round(parseFloat(ip.cpu_rate)), 
          "#FF6B26", 
          this.$I18n("cpu_usage")
        )
      } else {
        this.cpuCharts = getGauge(0, "#FF6B26", this.$I18n("cpu_usage"))
      }
      
      // 硬盘占用率
      if(ip.disk_rate){
        const disk_ls = JSON.parse(ip.disk_rate)
        var d_used = 0;
        var d_total= 0;
        disk_ls.forEach(i => {
          const used = parseFloat(i.used.replace("GB", ""))
          if(!isNaN(used)){
            d_used = d_used + used;
          }
          const total= parseFloat(i.total.replace("GB", ""))
          if(!isNaN(total)){
            d_total = d_total + total;
          }
        })
        if(d_total == 0){
          this.hdCharts = getGauge(0, "#4BE46A", this.$I18n("disk_usage"))
        } else {
          this.hdCharts = getGauge(Math.round(d_used*100/d_total), "#4BE46A", this.$I18n("disk_usage"))
        }
      } else {
        this.hdCharts = getGauge(0, "#4BE46A", this.$I18n("disk_usage"))
      }
    },
  },
  destoryed(){
    window.removeEventListener('resize', this.resizeCharts)
  },
  mounted(){
    // 获取IP列表
    this.getIpServer();
  },
  methods:{
    chartsInit(){
      // 绑定window resize
      window.addEventListener('resize', this.resizeCharts)
      // 时间
      const week = [6,5,4,3,2,1,0].map(i => nDaysAgo(i)); // 6天前到今日
      const w_day = week.map(i => i.slice(5)); // 6日到今日(MM-DD)
      const icc_week = [7,6,5,4,3,2,1].map(i => nDaysAgo(i)); // 6天前到今日

      // 1: 服务器信息
      this.memoryCharts = getGauge(0 , "#4BAAE4", this.$I18n("mem_usage"))
      this.cpuCharts = getGauge(0, "#FF6B26", this.$I18n("cpu_usage"))
      this.hdCharts = getGauge(0, "#4BE46A", this.$I18n("disk_usage"))
      // 4: 物联网卡
      this.ncCharts = getBar(
        icc_week,
        [
          w_day.map(() => 0),
          w_day.map(() => 0)
        ],
        [this.$I18n("iot_card_board"), this.$I18n("corr_card")],
        [
          ['rgba(80, 130, 222, 1)', 'rgba(80, 130, 222, 0.35)'],
          ['rgba(255, 165, 113, 1)', 'rgba(249, 153, 74, 0.5)']
        ]
      );
      // 5: 本周电话外呼统计  
      this.phCharts = getBar(
        w_day,
        [w_day.map(() => 0), w_day.map(() => 0)],
        [this.$I18n("ph_con"), this.$I18n("ph_no_con")],
        [
          ['rgba(68,224,105,1)', 'rgba(68,224,105,0.35)'],
          ['rgba(255, 165, 113, 1)', 'rgba(249, 153, 74, 0.5)']
        ]
      );
      // 6: 今日短信统计
      this.msgCharts = getPie(
        "0",
        [
          {value: 0, name: this.$I18n("succ_num"), color: '#00E0DB'},
          {value: 0, name: this.$I18n("fail_num"), color: '#D1002D'}
        ],
      )
      // 7：每周短信统计
      this.smweekCharts = getLine(
        w_day,
        [
          {
            name: this.$I18n("succ_num"),
            color:"#FFA06C",
            data: w_day.map(() => 0), 
          },{
            name: this.$I18n("fail_num"),
            color:"#66FFFF",
            data: w_day.map(() => 0), 
          },
        ]
      );
      // 8：今日邮件统计
      this.emweekCharts = getLine(
        w_day,
        [
          {
            name: this.$I18n("succ_num"),
            color:"#FFA06C",
            data: w_day.map(() => 0), 
          },{
            name: this.$I18n("fail_num"),
            color:"#66FFFF",
            data: w_day.map(() => 0), 
          },
        ]
      );
      // 9：每周邮件统计
      this.emdayCharts = getPie(
        String(0),
        [
          {value: 0, name: this.$I18n("succ_num"), color: 'rgba(0,209,200,1)'},
          {value: 0, name: this.$I18n("fail_num"), color: 'rgba(255,168,27,1)'},
        ]
      );
      // 11：UID授权
      this.uidCharts = getPie(
        String(0),
        [
          {value: 0, name: this.$I18n("avai_quan"), color: 'rgba(0,209,200,1)'},
          {value: 0, name: this.$I18n("used_quan"), color: 'rgba(255,168,27,1)'},
        ]
      );
      // 12：本周注册用户
      this.regCharts = getLine(
        w_day,
        [
          {
            name: this.$I18n("mng_num"),
            color:"#FFA06C",
            data: w_day.map(() => 0), 
          },{
            name: this.$I18n("add_new"),
            color:"#66FFFF",
            data: w_day.map(() => 0), 
          },
        ]
      );

      // 14: 本周设备状态
      this.wDevCharts = getLine(
        icc_week,
        [
          {
            name: this.$I18n("on_c"),
            color:"#FFA06C",
            data: w_day.map(() => 0), 
          },{
            name: this.$I18n("off_c"),
            color:"#66FFFF",
            data: w_day.map(() => 0), 
          },
        ]
      );
      // 15: 本周设备授权
      this.wAuthCharts = getLine(
        icc_week,
        [
          {
            name: this.$I18n("mng_num"),
            color:"#FFA06C",
            data: w_day.map(() => 0), 
          },{
            name: this.$I18n("used"),
            color:"#66FFFF",
            data: w_day.map(() => 0), 
          },
        ]
      );
    },
    setTimeToZero(timeStr){ // 将时间戳(YY-mm-DDThh:MM:ss)固定为0点0分0秒后 获取时间戳
      if(!timeStr){
        return 0
      }
      return new Date(timeStr.split("T")[0] + " 00:00:00").getTime()
    },
    // 2个组件(a,b)都显示的时候将其合并 
    comItem(a, b){
      const i_a = this.showItem.indexOf(a);
      const i_b = this.showItem.indexOf(b);
      // 6和11
      if(i_a > -1 && i_b > -1){ 
        this.showItem[Math.min(i_a,i_b)] = `${a}_${b}`;
        this.showItem = this.showItem.filter(i => i != a && i != b)
        console.log(this.showItem)
      }
    },
    getIpServer(){
      this.$api.getDashboardInfo_one({
        comp_path: this.UserInfo.comp_path,
        sys: this.userinfo_sys,
        push: {
          gmt_start : new Date(nDaysAgo(6).split(" ")[0] + " 00:00:00").getTime() / 1000,
          gmt_end   : new Date(nDaysAgo(0).split(" ")[0] + " 23:59:59").getTime() / 1000,
        },
        user: {
          gmt_start : new Date(nDaysAgo(6).split(" ")[0] + " 00:00:00").getTime() / 1000,
          gmt_end   : new Date(nDaysAgo(0).split(" ")[0] + " 23:59:59").getTime() / 1000,
        },
        iccid: {
          gmt_start : new Date(nDaysAgo(7).split(" ")[0] + " 00:00:00").getTime() / 1000,
          gmt_end   : new Date(nDaysAgo(1).split(" ")[0] + " 23:59:59").getTime() / 1000,
        },
        todo: {
          state: 1,
        },
        dev: {
          gmt_start : new Date(nDaysAgo(7).split(" ")[0] + " 00:00:00").getTime() / 1000,
          gmt_end   : new Date(nDaysAgo(1).split(" ")[0] + " 23:59:59").getTime() / 1000,
        },
      })
        .then(this.$Then(res => {
          this.showItem = JSON.parse(res.data?.role?.data_analysis ?? "[]").filter(i => showItemList.includes(i));

          // 6和11同时存在的时候将两者合并
          this.comItem(6, 11)

          setTimeout(() => {
            this.chartsInit();
            // 时间
            const today = new Date(nDaysAgo(0)+ " 00:00:00").getTime();
            const week = [6,5,4,3,2,1,0].map(i => nDaysAgo(i)); // 6天前到今日
            const w_day = week.map(i => i.slice(5)); // 6日到今日(MM-DD)
            const w_ts = week.map(i => new Date(i + " 00:00:00").getTime())

            const icc_week = [7,6,5,4,3,2,1].map(i => nDaysAgo(i)); // 6天前到今日

            // IP初始值
            this.ips = res.data?.svc_list?.data ?? [];
            if(res.data?.svc_list?.data?.length > 0){
              this.sl_ip = res.data.svc_list.data[0].id;
            }

            if(res?.data?.push_analysis){
              const cp = res.data.push_analysis;

              // 3：今日报警推送记录
              if(cp.alarm){
                const td_alm = cp.alarm.filter(i => this.setTimeToZero(i.created_at) === today)[0];
                if(td_alm){
                  this.alm_s = td_alm?.data_state?.sc ?? 0
                  this.alm_f = td_alm?.data_state?.fc ?? 0
                }
              }
              // 5：本周电话外呼统计
              if(cp.voice){
                var conList = w_day.map(() => 0);
                var nconList = w_day.map(() => 0);
                cp.voice.forEach(i => {
                  const index = w_ts.indexOf(this.setTimeToZero(i.created_at));
                  if(index > -1){
                    conList[index] = i?.data_state?.sc;
                    nconList[index]= i?.data_state?.fc;
                  }
                })
                this.phCharts = (getBar(
                  w_day,
                  [conList, nconList],
                  [this.$I18n("ph_con"), this.$I18n("ph_no_con")],
                  [
                    ['rgba(68,224,105,1)', 'rgba(68,224,105,0.35)'],
                    ['rgba(255, 165, 113, 1)', 'rgba(249, 153, 74, 0.5)']
                  ]
                ));
              }

              
              if(cp.sms){
                // 6：今日短信统计
                const td_sms = cp.sms.filter(i => this.setTimeToZero(i.created_at) === today)[0];
                if(td_sms){
                  const sms_s = td_sms?.data_state?.sc ?? 0;
                  const sms_f = td_sms?.data_state?.fc ?? 0;
                  this.msgCharts = (getPie(
                    String(sms_s + sms_f),
                    [
                      {value: sms_s, name: this.$I18n("succ_num"), color: '#00E0DB'},
                      {value: sms_f, name: this.$I18n("fail_num"), color: '#D1002D'}
                    ],
                  ))
                }

                // 7：每周短信统计
                var smsList = w_day.map(() => 0);
                var nsmsList = w_day.map(() => 0);
                cp.sms.forEach(i => {
                  const index = w_ts.indexOf(this.setTimeToZero(i.created_at));
                  if(index > -1){
                    smsList[index] = i?.data_state?.sc;
                    nsmsList[index]= i?.data_state?.fc;
                  }
                });
                this.smweekCharts = (getLine(
                  w_day,
                  [
                    {
                      name: this.$I18n("succ_num"),
                      color:"#FFA06C",
                      data: smsList, 
                    },{
                      name: this.$I18n("fail_num"),
                      color:"#66FFFF",
                      data: nsmsList, 
                    },
                  ]
                ));
              }

              if(cp.email){
                // 8：今日邮件统计
                const td_email = cp.email.filter(i => this.setTimeToZero(i.created_at) === today)[0];
                if(td_email){
                  const email_s = td_email?.data_state?.sc ?? 0;
                  const email_f = td_email?.data_state?.fc ?? 0;
                  this.emdayCharts = (getPie(
                    String(email_s + email_f),
                    [
                      {value: email_s, name: this.$I18n("succ_num"), color: '#00E0DB'},
                      {value: email_f, name: this.$I18n("fail_num"), color: '#D1002D'}
                    ],
                  ));
                }
                // 9：每周邮件统计
                var emailList = w_day.map(() => 0);
                var nemailList = w_day.map(() => 0);
                cp.email.forEach(i => {
                  const index = w_ts.indexOf(this.setTimeToZero(i.created_at));
                  if(index > -1){
                    emailList[index] = i?.data_state?.sc;
                    nemailList[index]= i?.data_state?.fc;
                  }
                });
                this.emweekCharts = (getLine(
                  w_day,
                  [
                    {
                      name: this.$I18n("succ_num"),
                      color:"#FFA06C",
                      data: emailList, 
                    },{
                      name: this.$I18n("fail_num"),
                      color:"#66FFFF",
                      data: nemailList, 
                    },
                  ]
                ));
              }
            }

            if(res?.data?.dev_analysis){ 
              // 10：设备状态
              const dev = res.data.dev_analysis;
              this.p2p_on_c = dev?.p2p_online_count ?? 0;
              this.p2p_off_c = dev?.p2p_offline_count ?? 0;
              // 11：UID授权
              const all_c = dev?.auth_count ?? 0;
              const use_c = dev?.alloc_count ?? 0;
              if(!isNaN(all_c) && !isNaN(use_c)){
                // UID授权饼图
                this.uidCharts = (getPie(
                  String(all_c),
                  [
                    {value: Math.max(all_c - use_c, 0), name: this.$I18n("avai_quan"), color: 'rgba(0,209,200,1)'},
                    {value: use_c, name: this.$I18n("used_quan"), color: 'rgba(255,168,27,1)'},
                  ]
                ));
              }
            }
            // 4：物联网卡状态
            if(res?.data?.iccid_analysis?.sys){
              const icc_w_day = icc_week.map(i => i.slice(5)); // 6日到今日(MM-DD)
              const icc_w_ts = icc_week.map(i => new Date(i + " 00:00:00").getTime());
              // 4：物联网卡状态
              var total_icc = icc_w_day.map(() => 0);
              var off_icc = icc_w_day.map(() => 0);
              res.data.iccid_analysis.sys.forEach(i => {
                const index = icc_w_ts.indexOf(this.setTimeToZero(i.created_at));
                if(index > -1){
                  total_icc[index] = i?.total_count ?? 0;
                  off_icc[index]= i?.suspended_count ?? 0;
                }
              })
              this.ncCharts = (getBar(
                icc_w_day,
                [ total_icc, off_icc ],
                [this.$I18n("iot_card_board"), this.$I18n("corr_card")],
                [
                  ['rgba(80, 130, 222, 1)', 'rgba(80, 130, 222, 0.35)'],
                  ['rgba(255, 165, 113, 1)', 'rgba(249, 153, 74, 0.5)']
                ]
              ));
            }

            // 12：本周注册用户
            if(res?.data?.user_analysis?.sys){ 
              var sysList_t = w_day.map(() => 0);
              var sysList_a = w_day.map(() => 0);
              res.data.user_analysis.sys.forEach(i => {
                  const index = w_ts.indexOf(this.setTimeToZero(i.created_at));
                  if(index > -1){
                    sysList_t[index] = i?.total_count ?? 0;
                    sysList_a[index] = i?.reg_count ?? 0;
                  }
              });
              this.regCharts = (getLine(
                w_day,
                [
                  {
                    name: this.$I18n("mng_num"),
                    color:"#FFA06C",
                    data: sysList_t, 
                  },{
                    name: this.$I18n("add_new"),
                    color:"#66FFFF",
                    data: sysList_a, 
                  },
                ]
              ));
            }

            // 2：服务器状态
            if(res?.data?.svc_opt?.data){
              this.tableData_srv = res.data.svc_opt.data.map(i => {
                let t_type_name = ""
                if(i.type == 1){
                  t_type_name = this.$I18n("servers")
                } else if (i.type == 2){
                  t_type_name = this.$I18n("phone_plat")
                }

                let t_state_name = "";
                if(i.state == 1){
                  t_state_name = this.$I18n("ser_nm")
                } else if (i.state == 2){
                  t_state_name = this.$I18n("ser_disconn")
                }

                const t_update_time = timestampToString1000(i.gmt_update);
                return {
                  ...i,
                  t_type_name,
                  t_state_name,
                  t_update_time,
                }
              })
            }
            // 13：待办任务
            if(res?.data?.todos?.data){
              console.log(res.data.todos.data)
              this.tableData_agency = res.data.todos.data.map(item => {
                return {
                  ...item,
                  create_date: timestampToString1000(item.gmt_create),
                }
              })
            }

            // 14/15
            if(res?.data?.dev_analysis_list?.data){
              const x_w_day = icc_week.map(i => i.slice(5)); // 6日到今日(MM-DD)
              const t_w_ts = icc_week.map(i => new Date(i + " 00:00:00").getTime());

              // 14 本周设备状态
              var on_dev = x_w_day.map(() => 0);
              var off_dev = x_w_day.map(() => 0);
              // 15 本周设备授权
              var t_dev = x_w_day.map(() => 0);
              var u_dev = x_w_day.map(() => 0);

              res.data.dev_analysis_list.data.forEach(i => {
                const index = t_w_ts.indexOf(this.setTimeToZero(i.created_at));
                if(index > -1){
                  on_dev[index]= i?.p2p_online_count ?? 0;
                  off_dev[index]= i?.p2p_offline_count ?? 0;
                  t_dev[index]= i?.auth_count ?? 0;
                  u_dev[index]= i?.alloc_count ?? 0;
                }
              });
              // 14: 本周设备状态
              this.wDevCharts = getLine(
                x_w_day,
                [
                  {
                    name: this.$I18n("on_c"),
                    color:"#FFA06C",
                    data: on_dev, 
                  },{
                    name: this.$I18n("off_c"),
                    color:"#66FFFF",
                    data: off_dev, 
                  },
                ]
              );
              // 15: 本周设备授权
              this.wAuthCharts = getLine(
                x_w_day,
                [
                  {
                    name: this.$I18n("mng_num"),
                    color:"#FFA06C",
                    data: t_dev, 
                  },{
                    name: this.$I18n("used"),
                    color:"#66FFFF",
                    data: u_dev, 
                  },
                ]
              );
            }
          }, 10);
        }))

        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.ips = [];
        }))
    },
    resizeCharts(){},
  },
};
</script>
<style lang="css" scoped>
  .dashboard{
    overflow:auto;
  }
  .image{
    /*// height: 700px;*/
    color: #555;
    clear: both;
    background-repeat: no-repeat;
    background-size: cover;
    margin-left: 30px;
  }
  .main-div{
    display: flex;
    flex-direction: column;
    padding: 0 7px;
  }
  .title{
    font-weight: 600;
    color: #888;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
  }
  .sub-title{
    line-height: 30px;
    font-size: 14px;
    height: 30px;
    font-weight: 600;
    width: 100%;
  }
  /*卡片盒子*/
    .box-div{
      background:#FFF;
      position: relative;
      border-radius: 12px;
      padding: 20px 20px;
      width: 100%;
      height: 250px;
    }
    .box-div::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 12px;
      background: linear-gradient(135deg, #6DA5B8, #FFFFFF);
      padding: 2px;
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
    }
    .box-div.box-div-03{
      height: 250px;
      padding: 5px 5px;
    }
    .box-div-03>div{
      padding: 0 15px;
      overflow-y: auto;
      height: 100%;
    }
  /*卡片盒子-END*/
  .select-div{
    border: 1px solid #DFDFDF;
    border-radius: 4px;
  }
  .select-div /deep/ input {
    height: 30px;
  }
  /deep/ .el-input__inner{
    height: 30px;
    padding-left: 10px !important;
    line-height: 30px;
  }
  /deep/ .el-input__icon{
    line-height: 30px !important;
  }

  .ip-charts{
    margin-top: 0px;
    height: 178px;
    background: #FFF;
    flex: 1;
  }
  .flatinfo-charts, .net-card-charts, .msg-charts{
    height: 210px;
    width: 100%;
  }
  .small-img{
    margin: auto;
    margin-bottom: 5px;
  }
  /*小标题*/
    .small-title{
      font-size: 14px;
      color: #333;
      text-align: center;
      margin: 0;
      font-weight: 500;
    }
    /*今日报警推送记录*/
    .title-top{
      margin-bottom: 13px;
    }
    /*平台概览-设备状态*/
    .title-top-02{
      margin-bottom: 5px;
    }
  /*小标题-END*/
  .dashboard-table /deep/ td{
    border-width: 0 !important;
    padding: 6px 8px !important;
    height: 32px;
  }

  /*代办任务*/
  .quest {
    margin: 15px 10px 0;
    height: auto;
    line-height: 20px;
    display: flex;
    font-size: 15px;
    color: #333;
    font-weight: 400;
    font-family: PingFang SC;
  }
  .quest-info{
    flex: 1;
  }
  .quest-date{
    font-weight: 400;
  }
</style>
